import { render, staticRenderFns } from "./InvestorPortfolioV4.vue?vue&type=template&id=09d1545f&scoped=true&"
import script from "./InvestorPortfolioV4.vue?vue&type=script&lang=js&"
export * from "./InvestorPortfolioV4.vue?vue&type=script&lang=js&"
import style0 from "./InvestorPortfolioV4.vue?vue&type=style&index=0&id=09d1545f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d1545f",
  null
  
)

export default component.exports